[
  {
    "gameId": 1,
    "title": "Rival Forge Spades",
    "gameType": 0,
    "version": "1",
    "baseUrl": "https://spades.rivalforge.com/game-board/",
    "settings": {
      "mode": {
        "type": "select",
        "label": "Game Mode",
        "default": "Team",
        "options": [
          {
            "value": "Team",
            "label": "Team (2v2)"
          },
          {
            "value": "Singles",
            "label": "Singles (Survivors)"
          }
        ]
      },
      "winScore": {
        "type": "select",
        "label": "Win Score Target",
        "default": 250,
        "options": [
          {
            "value": 250,
            "label": "250 (Standard Short)"
          },
          {
            "value": 500,
            "label": "500 (Standard Long)"
          }
        ]
      },
      "loseScore": {
        "type": "select",
        "label": "Lose Score Penalty",
        "default": -200,
        "options": [
          {
            "value": -200,
            "label": "-200 (Standard Penalty)"
          },
          {
            "value": -100,
            "label": "-100 (Light Penalty)"
          }
        ]
      },
      "timer": {
        "type": "select",
        "label": "Turn Timer",
        "default": 30,
        "options": [
          {
            "value": 0,
            "label": "Off (0s)"
          },
          {
            "value": 15,
            "label": "15s"
          },
          {
            "value": 30,
            "label": "30s"
          },
          {
            "value": 45,
            "label": "45s"
          }
        ]
      },
      "isQuickPlay": {
        "type": "checkbox",
        "label": "Quick Play Mode (Auto-start match when 4 players join)",
        "default": false
      }
    }
  },
  {
    "gameId": 2,
    "title": "Rival Forge Backgammon",
    "gameType": 0,
    "version": "1",
    "baseUrl": "https://backgammon.rivalforge.com/game-board/"
  },
  {
    "gameId": 3,
    "title": "Rival Forge Canasta",
    "gameType": 0,
    "version": "1",
    "baseUrl": "https://canasta.rivalforge.com/game-board/"
  },
  {
    "gameId": 4,
    "title": "Rival Forge Pinochle",
    "gameType": 0,
    "version": "1",
    "baseUrl": "https://pinochle.rivalforge.com/game-board/"
  },
  {
    "gameId": 5,
    "title": "Quake II",
    "gameType": 2,
    "version": "1",
    "baseUrl": "https://www.rivalforge.com/",
    "command": {
      "args": [
        "+connect",
        "[IP_ADDRESS]:[PORT]",
        "+password",
        "[PASSWORD]",
        "+name",
        "[NAME]"
      ]
    },
    "settings": {
      "game": {
        "type": "select",
        "label": "Game",
        "default": "quake2",
        "options": [
          "quake2"
        ]
      },
      "map": {
        "type": "select",
        "label": "Starting Map",
        "default": "q2dm1",
        "options": [
          "q2dm1",
          "q2dm2",
          "q2dm3",
          "q2dm4",
          "q2dm5",
          "q2dm6",
          "q2dm7",
          "q2dm8"
        ],
        "optionsByMod": {
          "baseq2": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "ctf": [
            "q2ctf1",
            "q2ctf2",
            "q2ctf3",
            "q2ctf4",
            "q2ctf5",
            "q2ctf6",
            "q2ctf7",
            "q2ctf8"
          ],
          "action": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "rocket_arena": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "railwarz": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "lithium": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ]
        }
      },
      "mod": {
        "type": "select",
        "label": "Mod",
        "default": "baseq2",
        "options": [
          "baseq2",
          "ctf"
        ]
      },
      "maxPlayerCount": {
        "type": "number",
        "label": "Max Players",
        "default": 16,
        "min": 2,
        "max": 64
      },
      "roundTimer": {
        "type": "number",
        "label": "Round Timer (minutes)",
        "default": 15,
        "min": 1,
        "max": 60
      },
      "roundTimeLimit": {
        "type": "number",
        "label": "Round Time Limit (minutes)",
        "default": 15,
        "min": 1,
        "max": 60
      },
      "maps": {
        "type": "multiselect",
        "label": "Map Pool",
        "default": [
          "q2dm1",
          "q2dm3",
          "q2dm8"
        ],
        "options": [
          "q2dm1",
          "q2dm2",
          "q2dm3",
          "q2dm4",
          "q2dm5",
          "q2dm6",
          "q2dm7",
          "q2dm8"
        ],
        "optionsByMod": {
          "baseq2": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "ctf": [
            "q2ctf1",
            "q2ctf2",
            "q2ctf3",
            "q2ctf4",
            "q2ctf5",
            "q2ctf6",
            "q2ctf7",
            "q2ctf8"
          ],
          "action": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "rocket_arena": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "railwarz": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ],
          "lithium": [
            "q2dm1",
            "q2dm2",
            "q2dm3",
            "q2dm4",
            "q2dm5",
            "q2dm6",
            "q2dm7",
            "q2dm8"
          ]
        }
      }
    }
  },
  {
    "gameId": 6,
    "title": "Quake",
    "gameType": 2,
    "version": "1",
    "baseUrl": "https://www.rivalforge.com/",
    "command": {
      "args": [
        "+connect",
        "[IP_ADDRESS]:[PORT]",
        "+password",
        "[PASSWORD]",
        "+name",
        "[NAME]"
      ]
    },
    "settings": {
      "game": {
        "type": "select",
        "label": "Game",
        "default": "quake1",
        "options": [
          "quake1"
        ]
      },
      "map": {
        "type": "select",
        "label": "Starting Map",
        "default": "dm1",
        "options": [
          "dm1",
          "dm2",
          "dm3",
          "dm4",
          "dm5",
          "dm6",
          "dm7",
          "dm8"
        ]
      },
      "mod": {
        "type": "select",
        "label": "Mod",
        "default": "id1",
        "options": [
          "id1"
        ]
      },
      "maxPlayerCount": {
        "type": "number",
        "label": "Max Players",
        "default": 16,
        "min": 2,
        "max": 64
      },
      "roundTimer": {
        "type": "number",
        "label": "Round Timer (minutes)",
        "default": 15,
        "min": 1,
        "max": 60
      },
      "roundTimeLimit": {
        "type": "number",
        "label": "Round Time Limit (minutes)",
        "default": 15,
        "min": 1,
        "max": 60
      },
      "maps": {
        "type": "multiselect",
        "label": "Map Pool",
        "default": [
          "dm1",
          "dm2"
        ],
        "options": [
          "dm1",
          "dm2",
          "dm3"
        ]
      }
    }
  },
  {
    "gameId": 7,
    "title": "Rival Forge Uno",
    "gameType": 0,
    "version": "1",
    "baseUrl": "https://uno.rivalforge.com/room/"
  }
]